// extracted by mini-css-extract-plugin
export default {"container":"Marketing_container__ayvbs"};